import { ThunkAction } from 'redux-thunk';
import { getSteps, RootState } from './reducers';
import { Action } from 'redux';
import {
  deleteGiftCardCode,
  deleteVoucherCode,
  fetchCartItems,
  fetchCustomerData,
  fetchDataFormInputValues,
  fetchExpiration,
  fetchItemPrice,
  fetchItemPriceAsync,
  fetchOrderDetails,
  fetchShippingStepOptions,
  fetchSteps,
  fetchSystem,
  fetchTranslations,
  getCanRemoveItem,
  getNavigateStep,
  getPaymentConfig,
  getStepItems,
  getStepValid,
  getSuccess,
  getTerms,
  getWidgetConfig,
  getWidgetCustomization,
  postAddGiftCard,
  postAddItem,
  postChangeMileageOption,
  postCreateOrder,
  postCreateSaleOrder,
  postCustomerNotes,
  postDataFormInputValues,
  postGeoCode,
  postGiftCardCode,
  postPayPalCapture,
  postPayPalOrderCreate,
  postPayPalPlusCreateResource,
  postPayPalUpdateResource,
  postPersonalDetails,
  postPrepayment,
  postPrepaymentCode,
  postReserve,
  postSearchItems,
  postSelectPaymentSplit,
  postShippingMethod, postStepVisited,
  postStripeConfirmPaymentIntent,
  postStripeOtherPaymentIntent,
  postStripePaymentIntent,
  postVerifyPaymentIntent,
  postVoucher,
  postVoucherCode,
  postWidgetConfig,
  removeItem,
} from '../api';
import { AddToCartParams, Coordinates, DateRangeStr, HourRange } from '../types/types';
import { WidgetConfig, WidgetCustomization } from '../types/config';
import {
  BookingDetails,
  BookingDetailsDate,
  BookingDetailsItemMileage,
  BookingDetailsItemVariation,
  ErrorLayout,
  OrderDetails,
  ProcessingSpinnerContent,
  RtrError,
  SearchParams,
  SplitOption,
  Tags,
} from './types';
import { getQueryParam, historyReplaceStateQueryParams, removePaymentQueryParams, removePayPalQueryParams, removeStripeQueryParams } from '../utils/utils';
import { SearchOptions, SearchParameters } from '../components/rentware-search/utils';
import { getApiConfig } from '../config';
import { CodeStatus } from '../components/rtr-payment/utils/types';
import { ErrorType } from '../components/rtr-errors/utils';
import { hookAddToCart } from '../utils/tracking/hooks';

export const FETCH_SYSTEM = 'FETCH_SYSTEM';
export const FETCH_TRANSLATIONS = 'FETCH_TRANSLATIONS';
export const FETCH_STEPS = 'FETCH_STEPS';
export const FETCH_CART = 'FETCH_CART';
export const FETCH_ORDER_DETAILS = 'FETCH_ORDER_DETAILS';
export const REMOVE_ITEM_FROM_CART = 'REMOVE_ITEM_FROM_CART';
export const FETCH_SHIPPING_OPTIONS = 'FETCH_SHIPPING_OPTIONS';
export const INIT_PAYMENT = 'INIT_PAYMENT';
export const OPEN_CART = 'OPEN_CART';
export const OPEN_FILTERS = 'OPEN_FILTERS';
export const OPEN_CHECKOUT = 'OPEN_CHECKOUT';
export const OPEN_DETAILS = 'OPEN_DETAILS';
export const OPEN_GALLERY = 'OPEN_GALLERY';
export const CLOSE_CART = 'CLOSE_CART';
export const CLOSE_FILTERS = 'CLOSE_FILTERS';
export const CLOSE_CHECKOUT = 'CLOSE_CHECKOUT';
export const START_UPDATE_FILTERS = 'START_UPDATE_FILTERS';
export const FINISH_UPDATE_FILTERS = 'FINISH_UPDATE_FILTERS';
export const UPDATE_SEARCH_PARAMETERS = 'UPDATE_SEARCH_PARAMETERS';
export const UPDATE_SEARCH_OPTIONS = 'UPDATE_SEARCH_OPTIONS';
export const UPDATE_SEARCH_TAGS = 'UPDATE_SEARCH_TAGS';
export const OPEN_RESERVATION = 'OPEN_RESERVATION';
export const CLOSE_RESERVATION = 'CLOSE_RESERVATION';
export const OPEN_PROCESSING_SPINNER = 'OPEN_PROCESSING_SPINNER';
export const CLOSE_PROCESSING_SPINNER = 'CLOSE_PROCESSING_SPINNER';
export const CLOSE_DETAILS = 'CLOSE_DETAILS';
export const CHANGE_CURRENT_STEP = 'CHANGE_CURRENT_STEP';
export const CHANGE_LOCALE = 'CHANGE_LOCALE';
export const CHANGE_PAYMENT_METHOD = 'CHANGE_PAYMENT_METHOD';
export const CHANGE_PREPAY_STATUS = 'CHANGE_PREPAY_STATUS';
export const CHANGE_SECONDARY_PAYMENT_METHOD = 'CHANGE_SECONDARY_PAYMENT_METHOD';
export const REQUIRE_INIT = 'REQUIRE_INIT';
export const RE_INIT = 'RE_INIT';
export const CHANGE_SHIPPING_METHOD = 'CHANGE_SHIPPING_METHOD';
export const CHANGE_SHIPPING_ADDRESS = 'CHANGE_SHIPPING_ADDRESS';
export const BOOKING_COMPLETED = 'BOOKING_COMPLETED';
export const BOOKING_RESET = 'BOOKING_RESET';
export const BOOKING_EXPIRED = 'BOOKING_EXPIRED';
export const FETCH_CUSTOMER = 'FETCH_CUSTOMER';
export const FETCH_ITEMS_FOR_STEP_START = 'FETCH_ITEMS_FOR_STEP_START';
export const FETCH_ITEMS_FOR_STEP = 'FETCH_ITEMS_FOR_STEP';
export const FETCH_ITEMS_FOR_STEP_END = 'FETCH_ITEMS_FOR_STEP_END';
export const FETCH_TERMS = 'FETCH_TERMS';
export const PAYMENT_CANCELED = 'PAYMENT_CANCELED';
export const CHANGE_PAYMENT_SPLIT_OPTION = 'CHANGE_PAYMENT_SPLIT_OPTION';
export const CHANGE_RECURRING_PAYMENT_MODE = 'CHANGE_RECURRING_PAYMENT_MODE';
export const FETCH_SUCCESS = 'FETCH_SUCCESS';
export const COMPONENT_LOADED = 'COMPONENT_LOADED';
export const STEP_LOADED = 'STEP_LOADED';
export const STORE_BILLING_VALUES = 'STORE_BILLING_VALUES';
export const CHANGE_BOOKING_DATE = 'CHANGE_BOOKING_DATE';
export const CLEAR_LOCATION_ID = 'CLEAR_LOCATION_ID';
export const CHANGE_BOOKING_ITEM_MILEAGE = 'CHANGE_BOOKING_ITEM_MILEAGE';
export const CHANGE_BOOKING_ITEM_VARIATION = 'CHANGE_BOOKING_ITEM_VARIATION';
export const CHANGE_BOOKING_LOCATION = 'CHANGE_BOOKING_LOCATION';
export const CHANGE_BOOKING_PEOPLE = 'CHANGE_BOOKING_PEOPLE';
export const CHANGE_BOOKING_DETAILS = 'CHANGE_BOOKING_DETAILS';
export const UPDATE_CONFIG = 'UPDATE_CONFIG';
export const CHANGE_LOCATIONS = 'CHANGE_LOCATIONS';
export const ADD_ERROR = 'ADD_ERROR';
export const REMOVE_ERROR = 'REMOVE_ERROR';
export const REMOVE_ERROR_TYPE = 'REMOVE_ERROR_TYPE';
export const REMOVE_ERROR_KEY = 'REMOVE_ERROR_KEY';
export const NAVIGATE_TO_STEP_START = 'NAVIGATE_TO_STEP_START';
export const NAVIGATE_TO_STEP_END = 'NAVIGATE_TO_STEP_END';
export const DATA_FORM_SEND_START = 'DATA_FORM_SEND_START';
export const DATA_FORM_SEND_END = 'DATA_FORM_SEND_END';
export const DATA_FORM_FETCH_START = 'DATA_FORM_FETCH_START';
export const DATA_FORM_FETCH_END = 'DATA_FORM_FETCH_END';



export type AppThunk = ThunkAction<Promise<void>, RootState, void, Action>;

export const reInit =
  (accessToken: string, onSuccess: () => any): AppThunk =>
  async (dispatch, getState) => {
    dispatch({
      type: BOOKING_RESET,
    });

    dispatch({
      type: RE_INIT,
      payload: { accessToken: accessToken },
    });

    await init(() => {
      initSteps(() => {
        const savedOrderId = getState().app.bookingId;
        if (savedOrderId) {
          initForOrder(() => null, savedOrderId)(dispatch, getState);
        }
        onSuccess();
      })(dispatch, getState);
    })(dispatch, getState);
  };

export const requireInit =
  (onSuccess?: () => any): AppThunk =>
  async (dispatch, getState) => {
    // the logic must be called only once in the lifetime of application
    if (!getState().app.initialized) {
      // save it was initialized in state
      dispatch({
        type: REQUIRE_INIT,
        payload: {
          accessToken: getApiConfig().accessToken,
        },
      });

      setInterval(() => {
        const id = getState().orderDetails?.id;
        if (id) {
          fetchExpiration(
            id,
            data => {
              if (data.isExpired) {
                dispatch({
                  type: BOOKING_RESET,
                });
                // it must be dispatched after BOOKING_RESET so that expiration flag persists
                dispatch({
                  type: BOOKING_EXPIRED,
                });
              }
            },
            undefined,
          );
        }
      }, 30 * 1000);

      await init(() => {
        onSuccess?.();
        initSteps(() => {
          const savedOrderId = getState().app.bookingId;
          if (savedOrderId) {
            initForOrder(() => null, savedOrderId)(dispatch, getState);
          }
        })(dispatch, getState);
      })(dispatch, getState);
    }
  };

const init =
  (onSuccess?: () => any): AppThunk =>
  async (dispatch, getState) => {
    fetchSystem(
      getState().app?.locale,
      data => {
        dispatch({
          type: FETCH_SYSTEM,
          payload: data,
        });

        if (onSuccess) {
          onSuccess?.();
        }
      },
      () => null,
    );
  };

export const initSteps =
  (onSuccess: () => any, onError?: () => any): AppThunk =>
  async (dispatch, getState) => {
    const orderReference = getState().app.bookingId || getState().orderDetails?.id;

    fetchSteps(
      orderReference,
      data => {
        dispatch({
          type: FETCH_STEPS,
          payload: data,
        });

        if (onSuccess) {
          onSuccess();
        }
      },
      onError?.(),
    );
  };

export const initNoOrder =
  (orderReference: string, onPaymentSuccess?: () => any, onPaymentError?: () => any): AppThunk =>
  async (dispatch, getState) => {
    if (!getState().app.initialized) {
      // save it was initialized in state
      dispatch({
        type: REQUIRE_INIT,
        payload: {
          accessToken: getApiConfig().accessToken,
        },
      });

      await init();
    }

    const paymentParam = getQueryParam('rentware-payment');

    if (paymentParam) {
      switch (paymentParam) {
        case 'paypal-success':
          let paymentId = getQueryParam('paymentId');
          //@TODO change to token only after Paypal API V2 usage deployed within backend/api app
          //`token` is the parameter name for V2, `paymentId` is for V1
          if (!paymentId) {
            paymentId = getQueryParam('token');
          }

          //@INFO in v2 we dont need payerId - was optional in v1 (https://developer.paypal.com/docs/api/payments/v1/#payment_execute!ct=application/json&path=payer_id&t=request)
          //but now does not exist in v2 capture (https://developer.paypal.com/docs/api/orders/v2/#orders_capture)
          const payerId = getQueryParam('PayerID')

          postPayPalCapture(orderReference, paymentId, payerId, onPaymentSuccess, null);
          historyReplaceStateQueryParams(removePayPalQueryParams(new URLSearchParams(window.location.search)));
          break;
        case 'paypal-cancel':
          onPaymentError?.();
          historyReplaceStateQueryParams(removePayPalQueryParams(new URLSearchParams(window.location.search)));
          break;
        case 'stripe-source':
          const redirectStatus = getQueryParam('redirect_status');
          const paymentIntentId = getQueryParam('payment_intent');

          historyReplaceStateQueryParams(removeStripeQueryParams(new URLSearchParams(window.location.search)));

          if (redirectStatus !== 'failed') {
            postVerifyPaymentIntent(paymentIntentId, onPaymentSuccess, onPaymentError);
          } else {
            onPaymentError?.();
          }
          break;
      }

      historyReplaceStateQueryParams(removePaymentQueryParams(new URLSearchParams(window.location.search)));
    }
  };

export const completeBooking = (): AppThunk => async (dispatch, getState) => {
  dispatch(bookingCompletedEvent(getState()));
};

export const initForOrder =
  (onSuccess?: () => any, orderReference?: string): AppThunk =>
  async (dispatch, getState) => {
    const reference = orderReference ? orderReference : getState().orderDetails?.id;

    fetchOrderDetails(
      reference,
      data => {
        const orderDetails: OrderDetails = { ...data, id: reference };
        dispatch({
          type: FETCH_ORDER_DETAILS,
          payload: orderDetails,
        });

        // removed condition prevents displaying success page for Sofort, Ideal and Bancontact
        // if (getState().orderDetails && !getState().orderDetails?.isCompleted && !getState().orderDetails?.isExpired) {
        if (getState().orderDetails && !getState().orderDetails?.isExpired) {
          fetchCartItems(
            reference,
            cart => {
              dispatch({
                type: FETCH_CART,
                payload: cart,
              });
              onSuccess?.();

              const paymentParam = getQueryParam('rentware-payment');
              if (paymentParam) {
                const paymentStep = getSteps(getState()).find(item => item.kind === 'payment');
                switch (paymentParam) {
                  case 'paypal-success':
                    dispatch({
                      type: OPEN_PROCESSING_SPINNER,
                    });

                    let paymentId = getQueryParam('paymentId');
                    //@TODO change to token only after Paypal API V2 usage deployed within backend/api app
                    //`token` is the parameter name for V2, `paymentId` is for V1
                    if (!paymentId) {
                      paymentId = getQueryParam('token');
                    }

                    //@INFO in v2 we dont need payerId - was optional in v1 (https://developer.paypal.com/docs/api/payments/v1/#payment_execute!ct=application/json&path=payer_id&t=request)
                    //but now does not exist in v2 capture (https://developer.paypal.com/docs/api/orders/v2/#orders_capture)
                    const payerId = getQueryParam('PayerID')

                    postPayPalCapture(
                      reference,
                      paymentId,
                      payerId,
                      () => {
                        dispatch(bookingCompletedEvent(getState()));
                      },
                      () => {
                        dispatch({
                          type: PAYMENT_CANCELED,
                          payload: {
                            paymentStep,
                          },
                        });
                      },
                    );
                    historyReplaceStateQueryParams(removePayPalQueryParams(new URLSearchParams(window.location.search)));
                    break;
                  case 'paypal-cancel':
                    dispatch({
                      type: PAYMENT_CANCELED,
                      payload: {
                        paymentStep,
                      },
                    });
                    historyReplaceStateQueryParams(removePayPalQueryParams(new URLSearchParams(window.location.search)));
                    break;
                  case 'stripe-source':
                    const redirectStatus = getQueryParam('redirect_status');
                    const paymentIntentId = getQueryParam('payment_intent');
                    historyReplaceStateQueryParams(removeStripeQueryParams(new URLSearchParams(window.location.search)));

                    if (redirectStatus === 'failed') {
                      dispatch({
                        type: PAYMENT_CANCELED,
                        payload: {
                          paymentStep,
                        },
                      });
                    } else {
                      postVerifyPaymentIntent(
                        paymentIntentId,
                        () => {
                          dispatch(bookingCompletedEvent(getState()));
                        },
                        undefined,
                      );
                    }
                    break;
                }
              }
            },
            undefined,
          );
        }
      },
      undefined,
    );
  };

export const resetBooking =
  (onSuccess?: () => any): AppThunk =>
  async dispatch => {
    dispatch({
      type: BOOKING_RESET,
    });

    if (onSuccess) {
      onSuccess();
    }
  };

export const searchItems =
  (params: SearchParams, onSuccess: (data: any) => any, onError: () => any): AppThunk =>
  async () => {
    postSearchItems(params, onSuccess, onError);
  };

export const addGiftCardToCart =
  (value: number, amountToAdd: number, onSuccess: () => any, onError: (err: any) => any): AppThunk =>
  async (dispatch, getState) => {
    const state = getState();
    if (state.app.bookingExpired) {
      dispatch({
        type: BOOKING_RESET,
      });
    }

    // gift card can be added in quantity of 1 and only when no order created yet
    if (!state.orderDetails) {
      const payload = {
        value: value,
        lang: state.app.locale,
        referrer: window.location.origin + window.location.pathname,
      };

      postCreateSaleOrder(
        payload,
        data => {
          const orderReference = data.reference;

          initSteps(() => {
            postAddGiftCard(
              data.reference,
              getState().app.currentStep.id,
              value,
              amountToAdd,
              () => {
                initForOrder(onSuccess, orderReference)(dispatch, getState);
              },
              onError,
            );
          })(dispatch, getState);
        },
        err => {
          if (onError && typeof onError === 'function') {
            onError(err);
          }
        },
      );
    }
  };

export const fetchPrice =
  (
    itemId: string,
    variationId: string,
    dateRange: DateRangeStr,
    hourRange: HourRange,
    timeSlot: string,
    quantity: number,
    onSuccess: (price: any) => any,
    onError: () => any,
  ): AppThunk =>
  async (_, getState) => {
    const orderReference = getState().orderDetails?.id;
    const withTime = getState().widget.timePickerEnabled;

    fetchItemPrice(itemId, orderReference, variationId, dateRange, withTime ? hourRange : null, timeSlot, quantity, onSuccess, onError);
  };

export const fetchPriceAsync =
  (
    itemId: string,
    variationId: string,
    dateRange: DateRangeStr,
    hourRange: HourRange,
    timeSlot: string,
    quantity: number,
    onSuccess: (price: any) => any,
    onError: () => any,
  ): AppThunk =>
  async (_, getState) => {
    const orderReference = getState().orderDetails?.id;

    fetchItemPriceAsync(itemId, orderReference, variationId, dateRange, hourRange, timeSlot, quantity, onSuccess, onError);
  };

export const addItemToCart =
  (params: AddToCartParams, onSuccess: () => any, onError: (err: any) => any): AppThunk =>
  async (dispatch, getState) => {
    const state = getState();
    const currency = state.system?.unitsConfig?.currency;

    if (state.app.bookingExpired) {
      dispatch({
        type: BOOKING_RESET,
      });
    }

    if (!state.orderDetails) {
      const payload = {
        people: params.people || 1,
        fullDay: params.fullDay,
        fromDate: params.dateRange.from,
        toDate: params.dateRange.to,
        locationId: state.bookingDetails.selectedLocationId || params.locationId,
        lang: state.app.locale,
        isOfferMode: false,
        forItemId: params.itemId,
        timeSlot: params.timeSlot,
        referrer: window.location.origin + window.location.pathname,
      };

      postCreateOrder(
        payload,
        data => {
          const orderReference = data.reference;
          initSteps(() => {
            postAddItem(
              data.reference,
              params.itemId,
              getState().app.currentStep.id,
              params.variationsIds,
              params.mileageOptionId,
              params.amountToAdd,
              state.app?.paymentSplitOption,
              () => {
                initForOrder(() => null, orderReference)(dispatch, getState);
                onSuccess();
                hookAddToCart(params, currency);
              },
              onError,
            );
          })(dispatch, getState);
        },
        err => {
          //todo: make this working :) find out if function or object
          if (onError && typeof onError === 'function') {
            onError(err);
          }
        },
      );
    } else {
      postAddItem(
        state.orderDetails.id,
        params.itemId,
        state.app.currentStep.id,
        params.variationsIds,
        params.mileageOptionId,
        params.amountToAdd,
        state.app?.paymentSplitOption,
        () => {
          initForOrder(() => {
            onSuccess();
            hookAddToCart(params, currency);
          })(dispatch, getState);
        },
        onError,
      );
    }
  };

interface RemoveFromCartParams {
  itemId: string;
  amountToRemove?: number; // positive number
  variationsIds?: string[];
}

export const removeItemFromCart =
  (params: RemoveFromCartParams, onSuccess: () => any, onError: () => any): AppThunk =>
  async (dispatch, getState) => {
    const state = getState();

    removeItem(
      state.orderDetails.id,
      params.itemId,
      state.app.currentStep.id,
      params.amountToRemove,
      params.variationsIds,
      state.app?.paymentSplitOption,
      () => {
        initForOrder(() => {
          const totalQtyInCart = getState().cart.totalQuantity;

          dispatch({
            type: REMOVE_ITEM_FROM_CART,
            payload: {
              orderItemId: params.itemId,
              totalQtyInCart: totalQtyInCart,
            },
          });
          onSuccess();
        })(dispatch, getState);
      },
      onError,
    );
  };

export const canRemoveItemFromCart =
  (itemId: string, onSuccess: (data: any) => any, onError: () => any): AppThunk =>
  async (_, getState) => {
    const state = getState();

    getCanRemoveItem(itemId, state.orderDetails.id, state.app.currentStep?.id, onSuccess, onError);
  };

export const changeMileageOption =
  (itemId: string, mileageOptionId: string, onSuccess: () => any, onError: () => any): AppThunk =>
  async (_, getState) => {
    const state = getState();
    postChangeMileageOption(itemId, state.orderDetails.id, mileageOptionId, onSuccess, onError);
  };

export enum NavigateStepTo  {
  next =  'next',
  previous = 'previous',
  current = 'current',
}

export const navigateToStep = (to: NavigateStepTo, stepId?: string): AppThunk => async (dispatch, getState) => {
  dispatch({
    type: NAVIGATE_TO_STEP_START,
    payload: {},
  });

  getNavigateStep(
    to,
    stepId,
    getState().orderDetails?.id,
    data => {
      dispatch({
        type: NAVIGATE_TO_STEP_END,
        payload: {},
      });

      dispatch({
        type: CHANGE_CURRENT_STEP,
        payload: {...data, context: to},
      });
    },
    () => {
      dispatch({
        type: NAVIGATE_TO_STEP_END,
        payload: {},
      });
    },
  )
};

export const changeLocale =
  (locale, onSuccess?, onError?): AppThunk =>
  async dispatch => {
    dispatch({
      type: CHANGE_LOCALE,
      payload: locale,
    });

    fetchTranslations(
      locale,
      data => {
        dispatch({
          type: FETCH_TRANSLATIONS,
          payload: data,
        });

        onSuccess?.();
      },
      () => onError?.(),
    );
  };

export const changeLocations =
  (locations: any[]): AppThunk =>
  async dispatch => {
    dispatch({
      type: CHANGE_LOCATIONS,
      payload: locations,
    });
  };

export const goToStep =
  (stepId): AppThunk =>
  async (dispatch, getState) => {
    await navigateToStep(NavigateStepTo.previous, stepId)(dispatch, getState);
  };

export const payWithStripeCC =
  (orderReference: string, isOrder: boolean, paymentMethodData: any, onSuccess: (data: any) => any, onError: (errMsg?: string) => any): AppThunk =>
  async (dispatch, getState) => {
    postStripePaymentIntent(
      orderReference,
      isOrder,
      paymentMethodData,
      getState().app.paymentMethodRecurring,
      getState().app.paymentSplitOption,
      (data: any) => {
        if (onSuccess) {
          onSuccess(data);
        }
        if (!data.requiresAction) {
          dispatch(bookingCompletedEvent(getState()));
        }
      },
      err => {
        onError(err);
      },
    );
  };

export const payWithStripeBancontact =
  (orderReference: string, isOrder: boolean, onSuccess: (intentClientSecret: string) => any, onError: () => any): AppThunk =>
  async (_, getState) => {
    postStripeOtherPaymentIntent(
      orderReference,
      isOrder,
      'bancontact-stripe',
      getState().app.paymentMethodRecurring,
      getState().app.paymentSplitOption,
      intentClientSecret => {
        onSuccess(intentClientSecret);
      },
      onError,
    );
  };

export const payWithStripeExpressCheckout =
  (orderReference: string, isOrder: boolean, method: string, onSuccess: (intentClientSecret: string) => any, onError: () => any): AppThunk =>
    async (_, getState) => {
      postStripeOtherPaymentIntent(
        orderReference,
        isOrder,
        method,
        getState().app.paymentMethodRecurring,
        getState().app.paymentSplitOption,
        intentClientSecret => {
          onSuccess(intentClientSecret);
        },
        onError,
      );
    };

export const confirmPayWithStripeCC =
  (paymentIntentId: string, isOrder: boolean, onSuccess: () => any, onError: (err?: any) => any): AppThunk =>
  async (dispatch, getState) => {
    postStripeConfirmPaymentIntent(
      paymentIntentId,
      () => {
        onSuccess?.();

        if (isOrder) {
          dispatch(bookingCompletedEvent(getState()));
        }
      },
      onError,
    );
  };

export const payWithPrePayment =
  (orderReference: string, onSuccess: () => any, onError: () => any): AppThunk =>
  async (dispatch, getState) => {
    postPrepayment(
      orderReference,
      getState().app.paymentSplitOption,
      () => {
        onSuccess();
        dispatch(bookingCompletedEvent(getState()));
      },
      onError,
    );
  };

export const payWithVoucher =
  (orderReference: string, onSuccess: () => any, onError: () => any): AppThunk =>
  async (dispatch, getState) => {
    postVoucher(
      orderReference,
      () => {
        onSuccess();
        dispatch(bookingCompletedEvent(getState()));
      },
      onError,
    );
  };

export const reserve =
  (orderReference: string, onSuccess: () => any, onError: () => any): AppThunk =>
  async (dispatch, getState) => {
    postReserve(
      orderReference,
      getState().app.paymentSplitOption,
      () => {
        onSuccess();
        dispatch(bookingCompletedEvent(getState()));
      },
      onError,
    );
  };

export const payWithPayPal =
  (orderReference: string, method: string, isOrder: boolean, onSuccess: (url: string) => any, onError: () => any): AppThunk =>
  async (_, getState) => {
    postPayPalOrderCreate(
      orderReference,
      method,
      getState().app.paymentSplitOption,
      isOrder,
      data => {
        onSuccess(data);
      },
      onError,
    );
  };

export const payPalPlusInit =
  (orderReference: string, onSuccess: (data: any) => any, onError: () => any): AppThunk =>
  async () => {
    postPayPalPlusCreateResource(
      orderReference,
      data => {
        onSuccess(data);
      },
      onError,
    );
  };

export const payPalPlusUpdate =
  (orderReference: string, paymentId: string, isOrder: boolean, onSuccess: () => any, onError: () => any): AppThunk =>
  async (_, getState) => {
    postPayPalUpdateResource(orderReference, paymentId, isOrder, getState().app.paymentSplitOption, onSuccess, onError);
  };

export const payWithStripeSofort =
  (orderReference: string, isOrder: boolean, onSuccess: (intentClientSecret: string) => any, onError: () => any): AppThunk =>
  async (_, getState) => {
    postStripeOtherPaymentIntent(
      orderReference,
      isOrder,
      'sofort-stripe',
      getState().app.paymentMethodRecurring,
      getState().app.paymentSplitOption,
      intentClientSecret => {
        onSuccess(intentClientSecret);
      },
      onError,
    );
  };

export const payWithStripeIdeal =
  (orderReference: string, isOrder: boolean, onSuccess: (intentClientSecret: string) => any, onError: () => any): AppThunk =>
  async (_, getState) => {
    postStripeOtherPaymentIntent(
      orderReference,
      isOrder,
      'ideal-stripe',
      getState().app.paymentMethodRecurring,
      getState().app.paymentSplitOption,
      intentClientSecret => {
        onSuccess(intentClientSecret);
      },
      onError,
    );
  };

export const payWithStripeSepa =
  (orderReference: string, isOrder: boolean, onSuccess: (intentClientSecret: string) => any, onError: () => any): AppThunk =>
  async (_, getState) => {
    postStripeOtherPaymentIntent(
      orderReference,
      isOrder,
      'sepa-direct-debit-stripe',
      getState().app.paymentMethodRecurring,
      getState().app.paymentSplitOption,
      intentClientSecret => {
        onSuccess(intentClientSecret);
      },
      onError,
    );
  };

export const payWithStripeP24 =
  (orderReference: string, isOrder: boolean, onSuccess: (intentClientSecret: string) => any, onError: () => any): AppThunk =>
  async (_, getState) => {
    postStripeOtherPaymentIntent(
      orderReference,
      isOrder,
      'p24-stripe',
      getState().app.paymentMethodRecurring,
      getState().app.paymentSplitOption,
      intentClientSecret => {
        onSuccess(intentClientSecret);
      },
      onError,
    );
  };

export const payWithStripeBlik =
  (orderReference: string, isOrder: boolean, onSuccess: (intentClientSecret: string) => any, onError: () => any): AppThunk =>
  async (dispatch, getState) => {
    await openProcessingSpinner({
      text1: 'Potwierdź płatność w aplikacji bankowej.',
      text2: 'Przejdź do aplikacji Twojego banku i potwierdź płatność.',
    })(dispatch, getState);

    postStripeOtherPaymentIntent(
      orderReference,
      isOrder,
      'blik-stripe',
      getState().app.paymentMethodRecurring,
      getState().app.paymentSplitOption,
      intentClientSecret => {
        onSuccess(intentClientSecret);
      },
      onError,
    );
  };

export const payWithStripeTwint =
  (orderReference: string, isOrder: boolean, onSuccess: (intentClientSecret: string) => any, onError: () => any): AppThunk =>
    async (_, getState) => {
      postStripeOtherPaymentIntent(
        orderReference,
        isOrder,
        'twint-stripe',
        getState().app.paymentMethodRecurring,
        getState().app.paymentSplitOption,
        intentClientSecret => {
          onSuccess(intentClientSecret);
        },
        onError,
      );
    };

export const completeWithStripeSepa = (): AppThunk => async (dispatch, getState) => {
  dispatch(bookingCompletedEvent(getState()));
};

export const selectShippingMethod =
  (option: any, onSuccess: () => any, onError: () => any): AppThunk =>
  async (dispatch, getState) => {
    dispatch({
      type: CHANGE_SHIPPING_METHOD,
      payload: option,
    });
    postShippingMethod(getState().orderDetails.id, option.id, option.grossPrice, option.address, onSuccess, onError);
  };

export const changeShippingAddress =
  (address: string): AppThunk =>
  async dispatch => {
    dispatch({
      type: CHANGE_SHIPPING_ADDRESS,
      payload: address,
    });
  };

export const selectPaymentMethodOption =
  (option: any, secondary = false, isRecurring = false): AppThunk =>
  async dispatch => {
    const type = secondary ? CHANGE_SECONDARY_PAYMENT_METHOD : CHANGE_PAYMENT_METHOD;
    const payload = {
      ...option,
      isRecurring,
    };

    dispatch({
      type: type,
      payload: payload,
    });
  };

export const updatePrepayStatus =
  (status: CodeStatus): AppThunk =>
  async dispatch => {
    dispatch({
      type: CHANGE_PREPAY_STATUS,
      payload: status,
    });
  };

export const changeRecurringPaymentMode =
  (isRecurring: boolean): AppThunk =>
  async dispatch => {
    dispatch({
      type: CHANGE_RECURRING_PAYMENT_MODE,
      payload: isRecurring,
    });
  };

export const selectPaymentSplitOption =
  ({ orderReference, option, onSuccess, onError }: { orderReference: string; option: SplitOption; onSuccess: () => any; onError: () => any }): AppThunk =>
  async (dispatch, getState) => {
    postSelectPaymentSplit(
      orderReference || getState().orderDetails.id,
      option.extraCartItemId,
      option,
      () => {
        dispatch({
          type: CHANGE_PAYMENT_SPLIT_OPTION,
          payload: option,
        });
        onSuccess?.();
      },
      () => onError?.(),
    );
  };

export const prepareShippingStep =
  (coordinates?: Coordinates, address?: string, onSuccess?: () => any, onError?: () => any): AppThunk =>
  async (dispatch, getState) => {
    fetchShippingStepOptions(
      getState().orderDetails.id,
      data => {
        dispatch({
          type: FETCH_SHIPPING_OPTIONS,
          payload: data,
        });
        if (onSuccess) {
          onSuccess();
        }
      },
      onError,
      coordinates,
      address,
    );
  };

export const savePersonalDetails =
  (orderReference: string, values: any, isShipping: boolean, onSuccess: () => any, onError: () => any): AppThunk =>
  async () => {
    const shippingValues = {};
    if (isShipping) {
      Object.entries(values).forEach(([key, value]) => {
        if (key.startsWith('shipping.')) {
          shippingValues[key.substr(9)] = value;
        }
      });
    }

    postPersonalDetails(orderReference, isShipping ? shippingValues : values, isShipping, onSuccess, onError);
  };

export const initPayment =
  ({ orderReference, onSuccess, onError }: { orderReference: string; onSuccess?: () => any; onError?: () => any }): AppThunk =>
  async (dispatch, getState) => {
    getPaymentConfig(
      orderReference,
      getState().app.locale,
      data => {
        dispatch({
          type: INIT_PAYMENT,
          payload: data,
        });

        onSuccess?.();
      },
      () => {
        onError?.();
      },
    );
  };

export const openCheckout = (): AppThunk => async (dispatch, getState) => {
  await navigateToStep(NavigateStepTo.current)(dispatch, getState);

  dispatch({
    type: OPEN_CHECKOUT,
  });
};

export const closeCheckout = (): AppThunk => async (dispatch) => {
  dispatch({
    type: CLOSE_CHECKOUT,
  });
};

export const openProcessingSpinner =
  (content?: ProcessingSpinnerContent): AppThunk =>
  async dispatch => {
    dispatch({
      type: OPEN_PROCESSING_SPINNER,
      payload: content,
    });
  };

export const closeProcessingSpinner = (): AppThunk => async dispatch => {
  dispatch({
    type: CLOSE_PROCESSING_SPINNER,
  });
};

export const openGallery =
  (id): AppThunk =>
  async dispatch => {
    dispatch({
      type: OPEN_GALLERY,
      payload: { id: id },
    });
  };

export const openDetails =
  (id, scrollToCalendar = false): AppThunk =>
  async dispatch => {
    dispatch({
      type: OPEN_DETAILS,
      payload: { id: id, scrollToCalendar: scrollToCalendar },
    });
  };

export const closeDetails = (): AppThunk => async dispatch => {
  dispatch({
    type: CLOSE_DETAILS,
  });
};

export const openCart = (): AppThunk => async dispatch => {
  dispatch({
    type: OPEN_CART,
  });
};

export const closeCart = (): AppThunk => async dispatch => {
  dispatch({
    type: CLOSE_CART,
  });
};

export const openReservation =
  (itemId: string): AppThunk =>
  async dispatch => {
    dispatch({
      type: OPEN_RESERVATION,
      payload: itemId,
    });
  };

export const closeReservation = (): AppThunk => async dispatch => {
  dispatch({
    type: CLOSE_RESERVATION,
  });
};

export const closeFilters = (): AppThunk => async dispatch => {
  dispatch({
    type: CLOSE_FILTERS,
  });
};

export const startUpdateFilters = (): AppThunk => async dispatch => {
  dispatch({
    type: START_UPDATE_FILTERS,
  });
};

export const finishUpdateFilters = (): AppThunk => async dispatch => {
  dispatch({
    type: FINISH_UPDATE_FILTERS,
  });
};

export const updateSearchParameters =
  (params: SearchParameters): AppThunk =>
  async dispatch => {
    dispatch({
      type: UPDATE_SEARCH_PARAMETERS,
      payload: { params },
    });
  };

export const updateSearchOptions =
  (options: SearchOptions): AppThunk =>
  async dispatch => {
    dispatch({
      type: UPDATE_SEARCH_OPTIONS,
      payload: { options },
    });
  };

export const updateSearchTags =
  (tags: Tags): AppThunk =>
  async dispatch => {
    dispatch({
      type: UPDATE_SEARCH_TAGS,
      payload: { tags },
    });
  };

export const openFilters =
  (filter): AppThunk =>
  async dispatch => {
    dispatch({
      type: OPEN_FILTERS,
      payload: { filter },
    });
  };

export const fetchCustomer = (): AppThunk => async (dispatch, getState) => {
  fetchCustomerData(
    getState().orderDetails.id,
    ({ customer, address }) => {
      dispatch({
        type: FETCH_CUSTOMER,
        payload: { customer, address },
      });
    },
    undefined,
  );
};

export const fetchItemsForCurrentStep =
  (onSuccess?): AppThunk =>
  async (dispatch, getState) => {
    // in case of missing required parameters (can happen when cart was erased), do not call api.
    if (!getState().orderDetails || !getState().app.currentStep) {
      if (!!onSuccess) {
        onSuccess();
      }
    } else {
      dispatch({
        type: FETCH_ITEMS_FOR_STEP_START,
        payload: {},
      });

      getStepItems(
        getState().orderDetails?.id,
        getState().app.currentStep?.slug,
        data => {
          dispatch({
            type: FETCH_ITEMS_FOR_STEP,
            payload: data,
          });
          dispatch({
            type: FETCH_ITEMS_FOR_STEP_END,
            payload: {},
          });
          if (!!onSuccess) {
            onSuccess();
          }
        },
        () => {
          dispatch({
            type: FETCH_ITEMS_FOR_STEP_END,
            payload: {},
          });
        },
      );
    }
  };

export const checkCurrentStepValidity =
  (onSuccess: (valid: boolean, reason: any) => any, onError: () => any): AppThunk =>
  async (_, getState) => {
    getStepValid(
      getState().orderDetails.id,
      getState().app.currentStep.id,
      data => {
        if (onSuccess) {
          onSuccess(data.valid, data.reason);
        }
      },
      () => {
        if (onError) {
          onError();
        }
      },
    );
  };

export const fetchWidgetCustomization =
  (onSuccess: (data: WidgetCustomization) => any, onError: () => any): AppThunk =>
  async () => {
    getWidgetCustomization(
      data => {
        if (onSuccess) {
          onSuccess(data);
        }
      },
      () => {
        if (onError) {
          onError();
        }
      },
    );
  };

export const fetchWidgetConfig =
  (onSuccess?: () => any, onError?: () => any): AppThunk =>
  async dispatch => {
    getWidgetConfig(
      data => {
        dispatch({
          type: UPDATE_CONFIG,
          payload: data,
        });
        onSuccess?.();
      },
      () => {
        onError?.();
      },
    );
  };

export const saveWidgetConfig =
  (saveUrl: string, onSuccess: () => any, onError: () => any): AppThunk =>
  async (_, getState) => {
    postWidgetConfig(
      getState().system.widgetConfig,
      saveUrl,
      () => {
        if (onSuccess) {
          onSuccess();
        }
      },
      () => {
        if (onError) {
          onError();
        }
      },
    );
  };

export const updateWidgetConfig =
  (cfg: WidgetConfig): AppThunk =>
  async dispatch => {
    dispatch({
      type: UPDATE_CONFIG,
      payload: cfg,
    });
  };

export const addError =
  (err: RtrError): AppThunk =>
  async dispatch => {
    dispatch({
      type: ADD_ERROR,
      payload: { ...err, layout: ErrorLayout.Error },
    });
  };

export const addSuccess =
  (err: RtrError): AppThunk =>
  async dispatch => {
    dispatch({
      type: ADD_ERROR,
      payload: { ...err, layout: ErrorLayout.Success },
    });
  };

export const removeErrorKey =
  (errorKey: string): AppThunk =>
  async dispatch => {
    dispatch({
      type: REMOVE_ERROR_KEY,
      payload: errorKey,
    });
  };

export const removeErrorType =
  (type: ErrorType): AppThunk =>
  async dispatch => {
    dispatch({
      type: REMOVE_ERROR_TYPE,
      payload: type,
    });
  };

export const removeError =
  (err: RtrError): AppThunk =>
  async dispatch => {
    dispatch({
      type: REMOVE_ERROR,
      payload: err,
    });
  };

export const addVoucher =
  (code: string, onSuccess: () => any, onError: (data: any) => any): AppThunk =>
  async (_, getState) => {
    postVoucherCode(
      getState().orderDetails.id,
      code,
      getState().app.paymentSplitOption,
      () => {
        if (onSuccess) {
          onSuccess();
        }
      },
      err => {
        if (onError) {
          onError(err);
        }
      },
    );
  };

export const removeVoucher =
  (code: string, onSuccess: () => any, onError: () => any): AppThunk =>
  async (_, getState) => {
    deleteVoucherCode(
      getState().orderDetails.id,
      code,
      getState().app.paymentSplitOption,
      () => {
        if (onSuccess) {
          onSuccess();
        }
      },
      () => {
        if (onError) {
          onError();
        }
      },
    );
  };

export const saveCustomerNotes =
  (message: string, onSuccess: () => any, onError: () => any): AppThunk =>
  async (_, getState) => {
    postCustomerNotes(
      getState().orderDetails.id,
      message,
      () => {
        if (onSuccess) {
          onSuccess();
        }
      },
      () => {
        if (onError) {
          onError();
        }
      },
    );
  };

export const fetchTerms = (): AppThunk => async (dispatch, getState) => {
  getTerms(
    getState().app.locale,
    data => {
      dispatch({
        type: FETCH_TERMS,
        payload: data,
      });
    },
    undefined,
  );
};

export const markComponentAsLoaded =
  (name: string): AppThunk =>
  async dispatch => {
    dispatch({
      type: COMPONENT_LOADED,
      payload: name,
    });
  };

export const markStepAsLoaded =
  (id: string, context: string): AppThunk =>
  async (dispatch, getState) => {
    // trigger only if not yet marked as loaded
    if (!getState().app.loadedSteps?.[id]) {
      dispatch({
        type: STEP_LOADED,
        payload: id,
      });
    }

    postStepVisited(getState().orderDetails.id, id, context)
  };

export const fetchSuccess = (): AppThunk => async (dispatch, getState) => {
  getSuccess(
    getState().orderDetails.id,
    data => {
      dispatch({
        type: FETCH_SUCCESS,
        payload: data,
      });
    },
    undefined,
  );
};

export const fetchGeoCode =
  (query: string, onSuccess: (data: any) => any, onError?: any): AppThunk =>
  async (_, getState) => {
    postGeoCode(
      query,
      getState().orderDetails?.id,
      data => {
        onSuccess(data);
      },
      () => onError?.(),
    );
  };

function bookingCompletedEvent(state: RootState) {
  return {
    type: BOOKING_COMPLETED,
    payload: { cart: state.cart },
  };
}

export const redeemGiftCard =
  ({
    orderReference,
    code,
    splitOption,
    onSuccess,
    onError,
  }: {
    orderReference: string;
    code: string;
    splitOption: SplitOption;
    onSuccess: () => any;
    onError: () => any;
  }): AppThunk =>
  async () => {
    postGiftCardCode(
      orderReference,
      code,
      { ...splitOption },
      () => {
        if (onSuccess) {
          onSuccess();
        }
      },
      () => {
        if (onError) {
          onError();
        }
      },
    );
  };

export const removeGiftCard =
  ({ orderReference, code, onSuccess, onError }: { orderReference: string; code: string; onSuccess: () => any; onError: () => any }): AppThunk =>
  async () => {
    deleteGiftCardCode(
      orderReference,
      code,
      () => {
        if (onSuccess) {
          onSuccess();
        }
      },
      () => {
        if (onError) {
          onError();
        }
      },
    );
  };

export const redeemPrepaymentCode =
  (code: string, onSuccess?: () => any, onError?: () => any): AppThunk =>
  async (dispatch, getState) => {
    const reference = getState().orderDetails.id;

    postPrepaymentCode(
      reference,
      code,
      () => {
        fetchCartItems(
          reference,
          cart => {
            dispatch({
              type: FETCH_CART,
              payload: cart,
            });
            onSuccess?.();
          },
          onSuccess?.(),
        );
      },
      () => {
        onError?.();
      },
    );
  };

export const saveDataFormInputValues =
  (dataFormId: string, dataFormInputValues: FormData | { [key: string]: string }, onSuccess: () => any, onError: (err: any) => any): AppThunk =>
  async (dispatch, getState) => {
    dispatch({
      type: DATA_FORM_SEND_START,
      payload: {},
    });

    postDataFormInputValues(
      getState().orderDetails.id,
      dataFormId,
      dataFormInputValues,
      () => {
        dispatch({
          type: DATA_FORM_SEND_END,
          payload: {},
        });

        if (onSuccess) {
          onSuccess();
        }
      },
      err => {
        dispatch({
          type: DATA_FORM_SEND_END,
          payload: {},
        });

        if (onError) {
          onError(err);
        }
      },
    );
  };

export const getDataFormInputValues =
  (dataFormId: string, onSuccess: (data) => any, onError: () => any): AppThunk =>
  async (dispatch, getState) => {
    const orderReference = getState().orderDetails.id;
    dispatch({
      type: DATA_FORM_FETCH_START,
      payload: {},
    });

    fetchDataFormInputValues(
      orderReference,
      dataFormId,
      (data) => {
        dispatch({
          type: DATA_FORM_FETCH_END,
          payload: {},
        });

        if (onSuccess) {
          onSuccess(data);
        }

        fetchCartItems(
          orderReference,
          (cart) => {
            dispatch({
              type: FETCH_CART,
              payload: cart,
            });
          },
          undefined,
        );
      },
      () => {
        dispatch({
          type: DATA_FORM_FETCH_END,
          payload: {},
        });

        onError?.()
      },
    );
  };

export const storeBillingValues =
  (values): AppThunk =>
  async dispatch => {
    dispatch({
      type: STORE_BILLING_VALUES,
      payload: values,
    });
  };

export const changeBookingDate =
  (details: BookingDetailsDate): AppThunk =>
  async dispatch => {
    dispatch({
      type: CHANGE_BOOKING_DATE,
      payload: details,
    });
  };

export const clearLocationId = (): AppThunk => async dispatch => {
  dispatch({
    type: CLEAR_LOCATION_ID,
    payload: {},
  });
};

export const changeBookingMileage =
  (item: BookingDetailsItemMileage): AppThunk =>
  async dispatch => {
    dispatch({
      type: CHANGE_BOOKING_ITEM_MILEAGE,
      payload: item,
    });
  };

export const changeBookingVariation =
  (item: BookingDetailsItemVariation): AppThunk =>
  async dispatch => {
    dispatch({
      type: CHANGE_BOOKING_ITEM_VARIATION,
      payload: item,
    });
  };

export const changeBookingLocation =
  (locationId: string): AppThunk =>
  async dispatch => {
    dispatch({
      type: CHANGE_BOOKING_LOCATION,
      payload: locationId,
    });
  };

export const changeBookingPeople =
  (peopleNumber: number): AppThunk =>
  async dispatch => {
    dispatch({
      type: CHANGE_BOOKING_PEOPLE,
      payload: peopleNumber,
    });
  };

export const changeBookingDetails =
  (details: Partial<BookingDetails>): AppThunk =>
  async dispatch => {
    dispatch({
      type: CHANGE_BOOKING_DETAILS,
      payload: details,
    });
  };
